import { toast } from 'react-toastify'
import Cookies from 'js-cookie'
import { getLogout } from '../context/logincontext'

const BASE_URL = process.env.REACT_APP_API_URL + '/api/'
const ongoingRequests = {}
let toastId = null

export const apiFetch = async (endpoint, options = {}) => {
  const requestKey = `${endpoint}:${JSON.stringify(options)}`
  const logout = getLogout()

  if (ongoingRequests[requestKey]) {
    return ongoingRequests[requestKey]
  }

  const controller = new AbortController()
  const { signal } = controller

  const requestPromise = new Promise(async resolve => {
    try {
      // const token = localStorage.getItem('token')
      const token = Cookies.get('token')

      const defaultHeaders = {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.body instanceof FormData
          ? {}
          : { 'Content-Type': 'application/json' })
      }

      const response = await fetch(`${BASE_URL}${endpoint}`, {
        ...options,
        signal,
        headers: {
          'ngrok-skip-browser-warning': 'true',
          ...defaultHeaders,
          ...options.headers
        },
        credentials: 'include'
      })

      let responseData = {}
      try {
        responseData = await response.json()
      } catch (jsonError) {
        console.error('Invalid JSON response:', jsonError)
      }

      if (!response.ok) {
        // Do not show toast if endpoint is validate-script
        const suppressToast = endpoint === 'website/validate-script'
        if (response.status === 429) {
          if (!toast.isActive(toastId) && !suppressToast) {
            toastId = toast.warn(
              responseData.message || 'Too many requests. Try again later.',
              {
                position: 'bottom-center'
              }
            )
          }
        } else if (response.status === 400) {
          if (!toast.isActive(toastId) && !suppressToast) {
            toastId = toast.error(responseData.message || 'Bad Request.', {
              position: 'bottom-center'
            })
          }
          return
        } else if (response.status === 401) {
          if (!toast.isActive(toastId)) {
            toastId = toast.error(responseData.message || 'Bad Request.', {
              position: 'bottom-center'
            })
            setTimeout(() => {
              logout()
              window.location.href = '/'
            }, 3000)
          }
        } else {
          if (!toast.isActive(toastId) && !suppressToast) {
            toastId = toast.error(
              responseData.message || 'An error occurred.',
              {
                position: 'bottom-center'
              }
            )
          }
        }
      }

      resolve(responseData)
    } catch (error) {
      console.error('API Request Failed:', error)

      if (!toast.isActive(toastId) && endpoint !== 'validate-script') {
        toastId = toast.error(error.message || 'Something went wrong', {
          position: 'bottom-center'
        })
      }

      resolve({ message: error.message || 'Something went wrong' })
    } finally {
      delete ongoingRequests[requestKey]
    }
  })

  ongoingRequests[requestKey] = requestPromise
  return requestPromise
}
